exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: 0.104167rem;\n  height: 0.104167rem;\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  transform: rotate(180deg);\n}", ""]);

// exports
